var _rect, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcloudMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 32,
    height: 32,
    rx: 8,
    fill: "url(#paint0_linear_5612_108298)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1333 22.4815C26.1 22.4815 26.0333 22.5148 26 22.5148H7C6.96667 22.5148 6.9 22.5148 6.86667 22.4815L12.8 16.5481L14.0667 17.8481C15.4333 19.2481 17.6 19.2481 18.9667 17.8481L20.2333 16.5481L26.1333 22.4815ZM26.5 21.8481V10.0815C26.5 10.0148 26.5 9.94815 26.4667 9.91481C26.4333 9.98148 20.5667 16.0481 20.5667 16.0481L26.5 21.9815V21.8481ZM6.5 21.8815V10.1481C6.5 10.0815 6.5 10.0148 6.53333 9.98148C6.56667 10.0481 12.4333 16.1148 12.4333 16.1148L6.53333 22.0148C6.5 21.9815 6.5 21.9148 6.5 21.8815ZM26.1667 9.51481L18.6 17.2481C17.4333 18.4148 15.5667 18.4148 14.4333 17.2481L6.86667 9.51481C6.83333 9.48148 26.1667 9.51481 26.1667 9.51481Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5612_108298",
    x1: 16.4929,
    y1: 0.0142222,
    x2: 16.4929,
    y2: 31.9929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E51EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19E6FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcloudMail);
export default __webpack_public_path__ + "static/media/icloud-mail.f812c1f780bfd182214a7d6bb7252a54.svg";
export { ForwardRef as ReactComponent };